import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";
import moment from "moment";
export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Property Insurance Information": [
      {
        title: "Policy Name",
        dataIndex: "Nickname",
        key: "Nickname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Policy Start Date",
        dataIndex: "Policy Start Date",
        key: "Policy Start Date",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      {
        title: "Policy End Date",
        dataIndex: "Policy End Date",
        key: "Policy End Date",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      {
        title: "Insurance Company",
        dataIndex: "Carrier",
        key: "Carrier",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Policy Number",
        dataIndex: "Policy Number",
        key: "Policy Number",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Year Premium",
        dataIndex: "year_premium",
        key: "year_premium",
        render: (record) => (record ? record : "N/A"),
      },
      // actionColumn,
    ],
    "Agent Contact Information": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "company",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    Inventory: [
      {
        title: "Property Name",
        dataIndex: "name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Held Where",
        dataIndex: "city",
        key: "city",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Value",
        dataIndex: "total",
        key: "total",
        render: (record) =>
          record
            ? `$${record.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            : "N/A",
      },
      // actionColumn,
    ],
    "Property Tax Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Mortgage Information": [
      {
        title: "Mortgage Servicer",
        dataIndex: "Mortgage Servicer",
        key: "mortgageservicer",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "accountnumber",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Payment Due Date",
        dataIndex: "Payment Due Date",
        key: "paymentduedate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      {
        title: "Maturity Date",
        dataIndex: "Maturity Date",
        key: "maturitydate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
